/** Separador entre modelo/dispositivo y el User-Agent nativo en cabecera y BD. */
export const ENRICHED_USER_AGENT_SEPARATOR = ' | ';

export interface NavigatorUADataLike {
	mobile?: boolean;
	platform?: string;
	getHighEntropyValues?(hints: readonly string[]): Promise<{ model?: string; platformVersion?: string }>;
}

/**
 * Prefija el UA nativo con la etiqueta de dispositivo cuando existe.
 */
export function buildEnrichedUserAgent(deviceLabel: string | null | undefined, rawUserAgent: string): string {
	const label = deviceLabel?.trim();
	if (!label || !rawUserAgent) {
		return rawUserAgent || '';
	}
	return `${label}${ENRICHED_USER_AGENT_SEPARATOR}${rawUserAgent}`;
}

/**
 * Obtiene etiqueta de dispositivo vía Client Hints (UA-CH).
 * Sin `userAgentData` devuelve null (no se inventa prefijo).
 */
export async function resolveDeviceLabelFromNavigator(
	isMobile: boolean,
	getUserAgentData: () => NavigatorUADataLike | undefined = () =>
		(navigator as Navigator & { userAgentData?: NavigatorUADataLike }).userAgentData,
): Promise<string | null> {
	const uaData = getUserAgentData();
	if (!uaData) {
		return null;
	}

	const isMobileDevice = uaData.mobile ?? isMobile;
	const platform = uaData.platform?.trim() || '';

	try {
		const data = await uaData.getHighEntropyValues?.(['model', 'platformVersion']);
		const model = data?.model?.trim();
		if (model) {
			return model;
		}
	} catch {
		// Sin alta entropía: fallback a plataforma + tipo
	}

	if (platform) {
		return `${platform} (${isMobileDevice ? 'Generic Mobile' : 'Desktop'})`;
	}

	return null;
}
